var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title",class:{more: _vm.more},style:(_vm.h_padding)},[_c('h3',{staticClass:"font_normal font_16_black",style:({fontSize: this.font + 'px'})},[_vm._v(_vm._s(_vm.title))]),(_vm.more)?_c('span',[_c('router-link',{attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":require("@/assets/icons/more@2x.png"),"alt":""}})])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }